import usersUrlConstants from '../../constants/usersUrlConstants'

const users = () => usersUrlConstants.USERS_URL
const getUsersUrl = () => usersUrlConstants.BACK_USERS_URL
const getUsersProfileUrl = () => usersUrlConstants.BACK_USERS_PROFILE_URL
const getAllUsersUrl = (excludeLoggedUser: boolean | undefined = true) => `${usersUrlConstants.ORGANIZATION_USERS_URL}?elu=${excludeLoggedUser}`
const getUserRolesUrl = () => `${getUsersUrl()}roles`
const getRportAssignsUrl = () => usersUrlConstants.REPORT_ASSIGNS
const getVictimsUrl = (id: string | undefined = '') => `${usersUrlConstants.VICTIMS}${id}`
const getSubjectsUrl = (id: string | undefined = '') => `${usersUrlConstants.SUBJECTS}${id}`
const getReportingPartyUrl = (id: string | undefined = '') =>
  `${usersUrlConstants.REPORTING_PARTIES}${id}`
const getUserPresetsUrl = () => `${usersUrlConstants.PRESETS}/`

export default {
  users,
  getUsersUrl,
  getAllUsersUrl,
  getUserRolesUrl,
  getRportAssignsUrl,
  getVictimsUrl,
  getSubjectsUrl,
  getReportingPartyUrl,
  getUserPresetsUrl,
  getUsersProfileUrl,
}
